import React from 'react';
import { BookOpenIcon, LayersThreeIcon, LayoutAlt04Icon } from 'assets/icons';
import { VaultNavigationTabs } from 'common/enums';
import { classnames } from 'helpers/utils';
import { NewMenu } from '../vault-top-bar/components/new-menu';
import styles from './vault-bottom-nav.module.scss';

const tabs: {
  tab: VaultNavigationTabs;
  label: string;
  icon: React.ReactNode;
}[] = [
  {
    tab: VaultNavigationTabs.dashboard,
    label: 'Dashboard',
    icon: <LayoutAlt04Icon />,
  },
  {
    tab: VaultNavigationTabs.albums,
    label: 'Albums',
    icon: <LayersThreeIcon />,
  },
  {
    tab: VaultNavigationTabs.memories,
    label: 'Memories',
    icon: <BookOpenIcon />,
  },
];

type VaultBottomNavProps = {
  selectedTab: VaultNavigationTabs;
  onSelectTab: (tab: VaultNavigationTabs) => void;
  // The top bar's New menu, opened from the "+".
  // Absent for people who can't add anything (viewers).
  newMenu?: Omit<React.ComponentProps<typeof NewMenu>, 'variant'>;
};

// On phones the vault's tabs and New move to the bottom of the screen, as in
// the mobile app (GSBottomNav): a pill of tabs and the round "+".
export const VaultBottomNav = ({
  selectedTab,
  onSelectTab,
  newMenu,
}: VaultBottomNavProps) => (
  <nav className={styles.bottomNav} aria-label="Vault">
    <div className={styles.pill} role="tablist">
      {tabs.map(({ tab, label, icon }) => {
        const active = selectedTab === tab;
        return (
          <button
            key={tab}
            type="button"
            role="tab"
            aria-selected={active}
            className={classnames(styles.tab, { [styles.tabActive]: active })}
            onClick={() => onSelectTab(tab)}
          >
            {icon}
            <span className={styles.label}>{label}</span>
          </button>
        );
      })}
    </div>
    <div className={styles.addBackdrop}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      {newMenu && <NewMenu {...newMenu} variant="fab" />}
    </div>
  </nav>
);
